/*
---
name: Multiselect

author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'

description:
This widget supports up to 5 levels list.

Simple one level multiselect with equal elements required in options 'equality: true' and doesn't need any class to be set for the elements.

Two levels multiselect doesn't need any parameters or classes for the elements (it sets by default).

Three-five levels multiselect requires good structure of your list. Please be sure that you have WELL STRUCTURED LIST.

The list of elements should always follow in this order:
	1. top level - element with class 'joker' (has to be only one element of this type in your list)
	2. second level - elements with class 'ace' (if you have joker, be sure that you have at least 2 aces in your list)
	3. third level - elements with class 'king' (can be 0, one or multiple)
	4. fourth level - elements with class 'queen' (can be 0, one or multiple)
	5. fifth level - elements with class 'jack' (can be 0, one or multiple)

Also notice that the slaves of joker are always aces, the slaves of ace are always kings and so on ... (i.e. queen can't be slave of ace)

Here is an example of well structured list:
	<ul>
		<li class="joker">All</li>
			<li class="ace">ace 1</li>
				<li class="king">king 1</li>
				<li class="king">king 2</li>
				<li class="king">king 3</li>
			<li class="ace">ace 2</li>
				<li class="king">king 1</li>
					<li class="queen">queen 1</li>
						<li class="jack">jack 1</li>
						<li class="jack">jack 2</li>
				<li class="king">king 2</li>
			<li class="ace">ace 3</li>
				<li class="king">king 1</li>
				<li class="king">king 2</li>
				<li class="king">king 3</li>
				<li class="king">king 4</li>
					<li class="queen">queen 1</li>
					<li class="queen">queen 2</li>
				<li class="king">king 5</li>
			<li class="ace">ace 4</li>
	</ul>
...
*/

var Multiselect = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_multiselect',
		close_button: true, //display or not close button on the dropdown
		text_input: true,
		equality: false, //all elements are equal if true - no slaves or masters
		hide_selected: false,
		suspension_points: false,
		data_monitor : null,
		add_tiles: true,
		display_text_label: false,
		skip_first_change: false,//set monitor title during initialising without fire 'change' event (for rfo page angular directive)
		skip_mouse_cover: false,
		list_above: false,//list position
		click_on_init: true,//send click event for each checked element on download
		selectedIndexes: []
	},

	initialize: function(element, options){
		this.setOptions(options);
		this._element = element || document.getElement('.' + this.options.cls);

		if(this._element){
			this.build();
		}
	},

	_adaFix: function() {
		this.adaHandle = Core.adaUtility.associateToggleAndDropdown(this._monitor, this._list);
	},

	build: function(){
		var self = this;
		var opts = this.options;
		// debugger;
		var data_text = opts.data_monitor || this._element.getAttribute('data-monitor-text') || this._element.getAttribute('data-monitor-html') || '';
		var barsIconHtml = this._element.get('data-icon-bars') != null ? '<i class="fa fa-bars"></i>' : '';
		var sortDescIconHtml = '<i class="fa fa-sort-desc"></i>';
		var iconHtml = barsIconHtml || sortDescIconHtml;
		this._monitor = new Element('button', {'class': 'monitor clearfix', 'html': iconHtml + '<span class="text">' + data_text + '</text>'}).inject(this._element);
		this._list = this._element.getElement('ul');

		this._adaFix();

		// set default options
		if (this.options.selectedIndexes) {
			for (var i = 0; i < this.options.selectedIndexes.length; i++) {
				this._list.children[this.options.selectedIndexes[i]].addClass('_selected');
			}
		}

		if(opts.list_above)
			this._list_cont = new Element('div', {'class': opts.cls + '_list _above'}).adopt(this._list).inject(this._element, 'top');
		else
			this._list_cont = new Element('div', {'class': opts.cls + '_list'}).adopt(this._list).inject(this._element);

		this.add_close_button();

		this._label = this._monitor.getElement('span.text');

		if(this._label){
			this._label.init_text = this._label.get('text');

			if(this._label.init_text == '-- Select --' || this._label.init_text == 'Regions'){
				this.has_persistent_label = true;
      		}
		}

		this._monitor.addEvents({
			'click:relay(".monitor_element")': function(e, i){
				self._monitor.in_child = true;
			},

			'click': function(e){
				if(e && e.stop) e.stop();

		        if(self._monitor.in_child){
		          return;
		        }

		        if(self.opened || self._element.hasClass('in_text_input')){
		          self.close_list();
		        }else{
		          self.open_list();

		          if(self._text_input){
		            self._text_input.show();
		            self._text_input.focus();

		            self._text_input.focused = true;
		          }
		        }
		    }

			// 'click': function(){
			// 	if(self._monitor.in_child){
			// 		return;
			// 	}

			// 	if(self._text_input){
			// 		self._text_input.show();
			// 		self._text_input.focus();

			// 		self._text_input.focused = true;

			// 		return;
			// 	}

			// 	if(self.opened){
			// 		self.close_list();
			// 	}else{
			// 		self.open_list();
			// 	}
			// }
		});



		if(opts.suspension_points){
			this._monitor.addClass('_suspension');
		}

		$(document.body).addEvent(
			'click', function(e){
				if(self.opened && !self.in_element){
					self.close_list();
				}
			}
		);

		if(!opts.skip_mouse_cover)
			this._element.addEvents({
				'mouseenter': function(){
					self.in_element = true;
				},
				'mouseleave': function(){
					self.in_element = false;

					if(!opts.text_input && self.opened && !self.in_element){
						self.close_list();
					}
				}
			});

		var _children = this._children = this._list.getChildren();

		if(!opts.equality){
			this.add_relationship();
		}else{
			/////////////		toDo
			// for now works fine (Dec. 2013)
		}

		this.updates = 0;

		_children.each(function(_el, i){
			_el.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();

					if(!_el.just_clicked){
						self.toggle_element(_el);
						_el.just_clicked = true;

						self.fireEvent('click', [e, _el]);
					}

					(function(){
						_el.just_clicked = false;
					}).delay(200); //to prevent doubleclick on checkbox label
				},

				'mouseenter': function(){
					self.hover_element(_el, true);
				},

				'mouseleave': function(){
					self.hover_element(_el, false);
				}
			});

			var _label = _el.getElement('label');
			if(_label) _label.setProperty('for', '');

			_el._check = _el.getElement('input[type="checkbox"]');

			if(_el._check){
				if(_el._check.getAttribute('checked')){
					if (!opts.click_on_init) {
						self.toggle_element(_el);
					} else {
						_el.fireEvent('click');
					}
				}
				else{
					_el._check.checked = false;
				}
			}
		});

		if(opts.text_input){
			var limousine = this.limousine = new Multiselect.Limousine(this);
			this._text_input = limousine._field;

			this._text_input.addEvents({
				'focus': function(){
					self._element.addClass('in_text_input');
				},

				'blur': function(){
					if(self.in_element) return;

					self._element.removeClass('in_text_input');

					if(self._monitor.hasClass('_has_elements')){
						self._text_input.hide();
					}
				}
			});
		}

		if(opts.hide_selected){
			var _style = new Element('style').inject(this._element, 'before');

			var add_class = 'ts_' + new Date().getTime();
			var styles = '.w_multiselect.' + add_class + ' li._selected{ position: absolute; left: -100000px; }';

			if(Core.is_ie8()){
				_style.styleSheet.cssText = styles;
			}else{
				_style.set('html', styles);
			}

			this._element.addClass(add_class);
		}

		if(opts.skip_first_change){
			this.update_monitor(opts);
		}
	},

	add_relationship: function(){
		var _joker = this._list.getElement('.joker') || this._list.getFirst();
		_joker.addClass('joker');

		this._children.each(function(_el){
			if( !_el.hasClass('joker') &&
					!_el.hasClass('ace') &&
					!_el.hasClass('king') &&
					!_el.hasClass('queen') &&
					!_el.hasClass('jack'))
			{
				_el.addClass('ace');
			}
		});

		var _aces = _joker._slaves = this._list.getElements('.ace');

		if(!_aces || _aces.length == 0){
			return;
		}

		_aces.each(function(_el){
			_el._master = _joker;
			_el._slaves = [];
		});

		var _kings = this._list.getElements('.king');
		var _queens = this._list.getElements('.queen');
		var _jacks = this._list.getElements('.jack');

		if(_kings && _kings.length > 0){
			this.find_slaves(_aces, 'ace', 'king');

			if(_queens && _queens.length > 0){
				this.find_slaves(_kings, 'king', 'queen');

				if(_jacks && _jacks.length > 0){
					this.find_slaves(_queens, 'queen', 'jack');
				}
			}
		}
	},

	find_slaves: function(array, master_class, slave_class){
		var self = this;

		if(array.length == 0) return;

		array.each(function(_master){
			var add_child = false;

			self._children.each(function(_el){
				if(add_child){
					if(_el.hasClass(slave_class)){
						_master._slaves.push(_el);
						_el._master = _master;
						_el._slaves = [];
					}else if(_el.hasClass(master_class)){
						add_child = false;
						return;
					}
				}

				if(_el == _master){
					add_child = true;
				}
			});
		});
	},

	toggle_element: function(_el) {
		if(_el.hasClass('_selected')) {
			this.deselect_element(_el);
			this.deselect_master(_el);
		} else {
			this.select_element(_el);

			if(this._element.hasClass('_regions')) {
				this.deselect_master(_el);
			} else {
				this.select_master(_el);
			}
		}

		this.update_monitor();
	},

	select_element: function(_el){
		_el.addClass('_selected');

		if(_el._check && !_el._check.checked){
			_el._check.checked = true;
		}

		this.select_slaves(_el);
	},

	select_slaves: function(_el){
		var _slaves = _el._slaves;

		if(!_slaves || _slaves.length == 0) return;

		_slaves.each(function(_e){
			this.select_element(_e);
		}.bind(this));

		_el.slaves_selected = true;
	},

	select_master: function(_el){
		var _master = _el._master;

		while(_master){
			var master_selected = true;
			var _siblings = _master._slaves;

			if(_siblings && _siblings.length > 0){
				_siblings.each(function(_e){
					if(!_e.hasClass('_selected')){
						master_selected = false;
						return;
					}
				});
			}

			if(master_selected){
				_master.addClass('_selected');
			}

			_master = _master._master;
		}
	},

	deselect_element: function(_el){
		_el.removeClass('_selected');

		if(_el._check){
			_el._check.checked = false;
		}

		this.deselect_slaves(_el);
	},

	deselect_slaves: function(_el){
		var _slaves = _el._slaves;

		if(!_slaves || _slaves.length == 0) return;

		_slaves.each(function(_e){
			this.deselect_element(_e);
		}.bind(this));

		_el.slaves_selected = false;
	},

	deselect_master: function(_el){
		var _master = _el._master;

		if(!_master) return;

		_master.removeClass('_selected');
		this.deselect_master(_master);

		_el.slaves_selected = false;
	},

	update_monitor: function(opts){
		this.updates++;

		(function(){
			this.updates--;

			if(this.updates > 0) return;

			var _mes = [];

			this._children.each(function(_el){
				if(_el.hasClass('_selected')){
					var _master = _el._master;

					if(_master && _master.hasClass('_selected')){
						_mes.erase(_el);

						this.add_master_to_monitor(_master, _mes);
					}else{
						_mes.push(_el);
					}
				}else{
					_mes.erase(_el);
					_mes.erase(_master);
				}
			}.bind(this));

			this._monitor_elements = _mes.clean();

			this.update_monitor_view.delay(20, this);

			if(!opts || !opts.skip_first_change)
				this.fireEvent('change');

			this._element.fireEvent('change', [_mes]);
		}.bind(this)).delay(50);
	},

	update_monitor_view: function(){
    if(!this.options.add_tiles){
      if(this._label){
        var count = '';

        if(this._element.hasClass('_beds')){
        	count = this.count_beds();
        }
        else if(this._element.hasClass('_regions')){
        	count = this.count_regions();
        }else{
          if(this._monitor_elements.length > 0){
          	if(this._children.length > this._monitor_elements.length){
          		if(this.options.display_text_label){
          			this._monitor_elements.each(function(_el, i){
		          		count += (i==0? ' ' : ', ' ) + _el.get('text').trim();
		          	})
          		}
          		else{
            		count = ' (' + this._monitor_elements.length + ' of ' + this._children.length + ')';
          		}
          	}else{
          		count = this.has_persistent_label? 'All' : ' (All)';
            }
          }
        }

        if(this.has_persistent_label){
        	if(count == ''){
						this._label.set('html', this._label.init_text);
        	}else{
        		this._label.set('html', count);
        	}
        }else{
        	if(this._label.init_text == 'Regions' && count ==' all'){
        		this._label.set('html', 'All ' + this._label.init_text );
        	}
        	else{
        		this._label.set('html', this._label.init_text + (count? '<span>' + count + '</span>' : ''));
        	}
        }
      }

      return;
    }

    var _tiles = this._monitor.getElements('.monitor_element');
    var _me = [];

    this._monitor_elements.each(function(_el){
      if(_el._monitor){
        _me.push(_el._monitor);
      }
    });

    _tiles.each(function(_el){
      if(!_me.contains(_el)){
        this.remove_from_monitor_view(_el);
      }
    }.bind(this));

    this._monitor_elements.each(function(_el){
      this.add_to_monitor_view(_el);
    }.bind(this));

    if(this._monitor_elements.length > 0){
      this._monitor.addClass('_has_elements');
    }else{
      this._monitor.removeClass('_has_elements');
    }

    if(this._text_input){
      this._text_input.set('value', '');

      if(this._text_input.focused){
        this._text_input.show();
        this._text_input.focus();
      }
    }

    if(!this.options.suspension_points) return;

    this._suspension = this._suspension || new Element('div', {'class': 'suspension_points'});

    this._suspension.addEvent('click', function(e){
      if(e && e.stop) e.stop();

      this.open_list();
    }.bind(this));

    var _first = this._monitor.getElement('.monitor_element');

    if(_first){
      _first.addClass('_first');

      if(this._monitor_elements.length > 0){
        this._suspension.inject(_first);
      }else{
        this._suspension.dispose();
      }
    }

    this._suspension.set('html', this.get_suspension_content());
  },

  count_regions: function(){
		var count = '';
  	if(this._monitor_elements.length > 0){
	  	if(this._children.length > this._monitor_elements.length){
	  		if(this._monitor_elements.length == 1){
	  			this._monitor_elements.each(function(_el, i){
	      		count = _el.get('text').trim();
	      	})
	  		}
	  		else{
	    		count = this._monitor_elements.length  + ' Regions';
	  		}
	  	}else{
	  		count = 'All Regions';
	    }
	  }
	  else{
  		count = 'All Regions';
    }

	  return count;
  },

  count_beds: function(){
  	var count = '';
  	var i = 0;

    if(this._monitor_elements.length < this._children.length){
      this._children.each(function(_el){
        if(!_el.hasClass('_selected')) return;

        var text = (_el.getElement('input'))? _el.getElement('input').get('value') : _el.get('text');

        if(text == 'studio' || text == 'Studios' || text.toInt() == 10){
          text = 'ST';
        }else if (text.contains('One') || text.toInt() == 11){
          text = 1;
        }else if (text.contains('Two') || text.toInt() == 12){
          text = 2;
        }else if (text.contains('Three') || text.toInt() == 13){
          text = 3;
        }else if (text == '14,15,16') {
        	text = '4+';
        }else if (text.contains('Four') || text.toInt() == 14){
          text = 4;
        }else if (text.contains('Bed')){
          text = text.split(' Bed')[0];
        }else{
          text = ' ' + text.split(' Beds')[0];
        }

        count += text + ((i+1 != this._monitor_elements.length)? ', ' : '');
        i++;
      }.bind(this));

      if(i > 0){
      	count = count.trim();

        if(count == '1' || count == 'ST, 1'){
        	count = count + '<span> Bed</span>';
        }else if(count != 'ST'){
        	count = count + '<span> Beds</span>';
        }
      }
    }else{
      count = 'all';
    }

    if(this.has_persistent_label){
    	count = count.replace('ST', 'Studio');
    }else{
    	count = count == ''? '' : ' (' +  count + ')';
    }

    return count;
  },

	get_suspension_content: function(){
		if(this._element.hasClass('regions')){
			if(this._monitor_elements.length > 1){
				var other_nhs = 0;

				this._monitor_elements.each(function(_el){
					if(_el._monitor.hasClass('_first')) return;

					var __count_children = function(_e){
						if(!_e._slaves || _e._slaves.length == 0){
							other_nhs++;
						}else{
							_e._slaves.each(function(_element){
								__count_children(_element);
							});
						}
					};

					__count_children(_el);
				});

				this._suspension.addClass('_in_text');
				// return '+ <span> ' + other_nhs + '</span> other neighborhood' + ((other_nhs > 1)? 's' : '');
				return '+ <span> ' + other_nhs + '</span> more';
			}else{
				return 'add more';
			}
		}else{
			return '...';
		}
	},

	add_to_monitor_view: function(_el){
		if(_el._monitor) return;

		var self = this;
		var _inner_elements = _el.getChildren();

		if(!_inner_elements || _inner_elements.length == 0){
			_inner_elements = [_el];
		}

		var text = '';
		var i = 0;

		_inner_elements.each(function(_e){
			if(self.is_visible(_e)){
				text += (i > 0? ' ' : '') + _e.get('text');
				i++;
			}
		});

		var html = text + '<div class="deselect_element">&nbsp;</div>';
		var _monitor = _el._monitor = new Element('div', {'class': 'monitor_element', 'html': html});
		_monitor._parent = _el;

		if(this._text_input){
			_monitor.inject(this._text_input, 'before');
		}else{
			_monitor.inject(this._monitor);
		}

		_monitor.addEvents({
			'click': function(){
				_el.fireEvent('click');

				(function(){
					self._monitor.in_child = false;
				}).delay(50);

				self.open_list();
			},
			'mouseenter': function(){
				self._monitor.in_child = true;
			},
			'mouseleave': function(){
				self._monitor.in_child = false;
			}
		});
	},

	remove_from_monitor_view: function(_el){
		if(_el){
			_el.dispose();

			if(_el._parent && _el._parent._monitor){
				_el._parent._monitor = null;
			}
		}

		if((!this._monitor_elements || this._monitor_elements.length == 0) && this._text_input){
			this._text_input.show();
		//	 this._text_input.focus();
		}
	},

	add_master_to_monitor: function(_m, _mes){
		var _master = _m._master;

		while(_master){
			if(_master.hasClass('_selected')) return;
			_master = _master._master;
		}

		_mes.push(_master);
	},

	open_list: function(){
		this._element.addClass('_opened');
		this._list_cont.show();
		this._monitor.addClass('_active');

		if(this.options.list_above)
			this._list_cont.setStyle('top', -this._list_cont.getSize().y + 1);//1-for border

		this.opened = true;

		this.fireEvent('openList');
		this.adaHandle && this.adaHandle.onOpen();
	},

	close_list: function(){
		this._element.removeClass('_opened');
		this._list_cont.hide();
		this._monitor.removeClass('_active');
		this.opened = false;

		if(this._text_input){
			if(!this._monitor_elements || this._monitor_elements.length == 0){
				this._text_input.show();
			}else{
				this._text_input.hide();
			}

			this._text_input.focused = false;
			this._element.removeClass('in_text_input');
		}

		this.fireEvent('closeList');
		this.adaHandle && this.adaHandle.onClose();
	},

	hover_element: function(_el, action){
		if(!_el._slaves || _el._slaves.length == 0) return;

		_el._slaves.each(function(_e){
			if(action){
				_e.addClass('_hovered');
			}else{
				_e.removeClass('_hovered');
			}

			this.hover_element(_e, action);
		}.bind(this));
	},

	add_close_button: function(){
		var self = this;
		var opts = this.options;

		if(!opts.close_button) return;

		var _close_list = new Element('div', {'class': opts.cls + '_close', 'html': '&times;'}).inject(this._list_cont);

		_close_list.addEvent('click', function(e){
			if(e && e.stop) e.stop();

			self.close_list();
		});
	},

	is_visible: function(_el){
		return !( (typeOf(_el) != 'element') ||
							(_el.getStyle('display') == 'none') ||
							(_el.getStyle('visibility') == 'hidden') ||
							(_el.getStyle('opacity') == 0) ||
							(_el.getStyle('height').toInt() == 0 && _el.getStyle('overflow') == 'hidden') ||
							(_el.getStyle('width').toInt() == 0 && _el.getStyle('overflow') == 'hidden')
		);
	}
});

Multiselect.Limousine = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_multiselect_limousine'
	},

	initialize: function(element, options) {
		this.setOptions(options);
		this.multiselect = element;
		this._element = element._element;

		if(this._element){
			this.build();
		}
	},

	build: function(){
		var opts = this.options,
				self = this;

		this._monitor = this.multiselect._monitor;
		this._field = this._monitor.getElement('input');
		this._dropdownlist = this.multiselect._list_cont;

		this._field = new Element('input', {'type': 'text', 'maxlength': 20});
		this._monitor.adopt(this._field);
		this._monitor.addClass('_has_textfield');

		this._field.set('autocomplete', 'off').addClass(opts.cls+'_autocomplete');
		this._results = new Element('div', {'class': opts.cls+'_results'}).inject(this._element);
		this._no_results = new Element('span', {'class': opts.cls + '_no_results', 'text': 'No Suggestions'});

		this._results.addEvents({
			'click:relay(li.item)': function(i, e){
				this.handle_item_click(null, e);
			}.bind(this)
		});

		this._results.hide();
		this.attach_textfield_events();

		this._monitor.addEvents({
			'mouseenter': function(){ self.in_monitor = true; },
			'mouseleave': function(){ self.in_monitor = false; }
		});

		$(document.body).addEvent(
			'click', function(){
				if(!self.in_monitor){
					self.clear_results();
				}
			}
		);
	},

	attach_textfield_events: function() {
		this._field.removeEvents().addEvents({
			keyup: this.handle_keyup.bind(this),
			keydown: this.handle_keydown.bind(this),
			change: this.handle_change.bind(this),
			blur: this.handle_blur.bind(this),
			focus: this.handle_focus.bind(this),
			click: this.handle_click.bind(this)
		});
	},

	do_query: function(){
		var query_string = this._field.get('value').toString().trim().toLowerCase() || '';

		this.handle_change(query_string);

		query_string = query_string.trim();

		if(query_string == ''){
			this.multiselect.open_list();
			this._results.hide();

			return;
		}

		// this.multiselect.close_list();

		this.multiselect._element.removeClass('_opened');
		this.multiselect._list_cont.hide();
		this.multiselect.opened = false;


		this._results.show();

		// this.multiselect._element.addClass('_opened');

		this.fireEvent('beforeQuery', [this]);

		this.clear_results();
		this.multiselect._element.addClass('_toggled');

		var response_text = this.get_results(query_string);

		this.handle_response(response_text, query_string);
	},

	get_query_string: function(){
		return this._field.get('value').toString().trim().toLowerCase() || '';
	},

	get_results: function(string){
		var self = this;
		var items = [];
		this._items = [];

		self.has_results = false;

		this.multiselect._children.each(function(_el){
			if(_el.hasClass('_selected')) return;

			var _text_container = _el.getElement('label') || _el.getElement('span');

			var text = (_text_container || _el).get('text');

			var position = text.toLowerCase().indexOf(string);

			if(position > -1 && !items.contains(text)){
				var text_with_selection = text.slice(0, position) + '<b>' + text.slice(position, position + string.length) + '</b>' + text.slice(position + string.length);

				var _li = new Element('li', {'class': 'item', 'html': text_with_selection, 'data-value': text});

				_li._main_element = _el;
				items.push(text);
				self._items.push(_li);
				self.has_results = true;
			}
		});

		if(this._items.length > 0){
			return this.create_list();
		}else{
			return this._no_results;
		}
	},

	create_list: function(){
		var _ul = new Element('ul', {'class': 'items'});

		this._items.each(function(_el){
			_ul.adopt(_el);
		});

		return _ul;
	},

	clear_results: function(){
		this._items = [];
		this.has_results = false;

		this._results.hide().empty().removeClass('has_results');
		this.fireEvent('clearResults', [this]);

		this.multiselect._element.removeClass('_toggled');
	},

	handle_response: function(response, query_string){
		if(response == '') return;

		this._results.adopt(response);

		if(this._items.length > 0){
			this.navigate('down');
		}

		this._results.show();

		this.fireEvent('handleResponse', [this, this._results]);
	},

	handle_change: function(qs){
		var query_string = qs || this._field.get('value').toString().trim() || '';

		if(query_string == ''){
			this._monitor.getElement('.text').setStyle('visibility', 'visible');
		}else{
			this._monitor.getElement('.text').setStyle('visibility', 'hidden');
		}
	},

	handle_click: function(e){
		this.do_query();
	},

	handle_focus: function(e){
		var opts = this.options,
			query = this.get_query_string();

		if(opts.over_text != null && opts.over_text == query) {
			this._field.removeClass('inactive')
								 .set('value', '');
		}else{
			this._field.removeClass('inactive')
								 .select();
		}

		this.do_query();

		// this.fireEvent('textfieldFocus', [this]);
	},

	handle_blur: function(e) {
		if(this._field.get('value').toString().trim() == '') {
			this._field.addClass('inactive')
								 .set('value', '');
		}

		// this.fireEvent('textfieldBlur', [this]);
	},

	handle_item_click: function(e, target){
		if(!target) return;

		if(e && e.stop){
			e.stop();
		}

		target._main_element.fireEvent('click');
		this.clear_results();
	},

	handle_enterkey: function(){
		var _selected = this._results.getElement('.item.selected');

		if(_selected){
			this.handle_item_click(null, _selected);
		}
	},

	handle_keydown: function(e){
		if (e && e.key) {
			switch (e.key) {
				case 'enter':
					this.handle_enterkey();
					break;
				case 'up': case 'down':
					this.navigate(e.key);
					break;
				case 'left': case 'right':
					break;
			 }
		 }
	},

	handle_keyup: function(e){
		if(e && e.key) {
			switch(e.key){
				case 'esc': case 'tab':
					this._field.set('value', '');
					this.multiselect._element.removeClass('_opened');
					this.clear_results();
					break;

				case 'up': case 'down':
					return false;

				case 'left': case 'right':
					return true;

				default:
					var query_string = this.get_query_string();

					if(query_string && query_string.length < this.options.min_chars){
						this.clear_results();
					}else{
						this.do_query();
					}
			}
		}
	},

	navigate: function(direction){
		var index = -1;

		this._items.each(function(_el, i){
			if(_el.hasClass('selected')){
				_el.removeClass('selected');
				index = i;
			}
		});

		index = (direction == 'up') ? index-1 : (direction == 'down' ?	index+1 : index);
		index = index < 0 ? this._items.length - 1 : ( index > this._items.length - 1 ? 0 : index );

		var _item = this._items[index];

		if(_item){
			_item.addClass('selected');
		}
	}
});
